// localhost - DESENV
//export const setBaseURL = "http://192.168.1.188:64001/troltech/metodos/";

// SECEGSERVER - DESENV
//export const setBaseURL = "https://www.secegservicos.com.br:65105/troltech/metodos/";

// SECEGSERVER - PRODUÇÃO
//export const setBaseURL = "https://www.secegservicos.com.br:65092/troltech/metodos/";



//////////////////////////////////
//    01/01/2026
//////////////////////////////////

// SECEGSERVER - PRODUÇÃO - BFF
export const setBaseURL = "https://www.secegservicos.com.br:65098/api/";

// SECEGSERVER - DESENV - BFF
//export const setBaseURL = "https://www.secegservicos.com.br:65103/api/";

// localhost
//export const setBaseURL = "http://localhost:67001/api/";

export default setBaseURL;